import { useState } from "react";

import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { useToast } from "@/components/toast";
import { BackHeader } from "@/components/back-header";
import { Toggle } from "@/components/ui";

const ROWS = [
  { key: "show_online_status", title: "Show online status", text: "Let members see when you were recently active." },
  { key: "hide_from_discovery", title: "Hide my profile from discovery", text: "You won’t appear in anyone’s matches. Existing connections stay." },
  { key: "email_on_new_request", title: "Email me about new requests", text: "A short email when someone sends you a request. Never includes contact details." },
  { key: "whatsapp", title: "Share WhatsApp with connections", text: "Global switch. Your number is only revealed to mutually accepted connections." },
];

export default function PrivacySettings() {
  const toast = useToast();
  const { user, setUser } = useAuth();
  const [busy, setBusy] = useState(null);
  if (!user) return null;
  const value = (k) => (k === "whatsapp" ? user.whatsapp_sharing_consent : k === "hide_from_discovery" ? !!user.privacy?.[k] : user.privacy?.[k] !== false);
  const change = async (k, v) => {
    setBusy(k);
    try {
      const u = k === "whatsapp"
        ? await api("/profile/whatsapp-consent", { method: "PUT", body: { whatsapp_sharing_consent: v } })
        : await api("/profile/privacy", { method: "PUT", body: { [k]: v } });
      setUser(u);
      toast("Privacy setting saved", "success");
    } catch (e) { toast(e.message, "error"); } finally { setBusy(null); }
  };
  return (
    <div data-testid="privacy-settings-screen" className="mx-auto max-w-2xl">
      <BackHeader title="Privacy Settings" />
      <div className="overflow-hidden rounded-[20px] border border-border bg-white">
        {ROWS.map((r) => (
          <div key={r.key} className="flex items-center gap-4 border-b border-border p-4 last:border-b-0">
            <div className="flex-1"><p className="text-[15px] font-bold">{r.title}</p><p className="mt-0.5 text-xs text-muted-foreground">{r.text}</p></div>
            <Toggle testId={`privacy-switch-${r.key}`} label={r.title} disabled={busy === r.key} checked={value(r.key)} onChange={(v) => change(r.key, v)} />
          </div>
        ))}
      </div>
      <p className="mt-4 text-xs text-muted-foreground">Revoking access cannot erase a number already copied or saved by the other person.</p>
    </div>
  );
}
